import React from 'react';
import { FormControl } from '@material-ui/core';
import GridItem from 'components/Grid/GridItem.jsx';
import { Field } from 'redux-form';

export const FullField = props => (
	<GridItem
		xs={12}
		sm={12}
		md={12}
		style={props.gridStyle ? { ...props.gridStyle } : { marginBottom: '25px' }}
	>
		<FormControl fullWidth>
			<Field {...props} />
		</FormControl>
	</GridItem>
);

export const HalfField = props => (
	<GridItem
		xs={12}
		sm={12}
		md={6}
		style={props.gridStyle ? { ...props.gridStyle } : { marginBottom: '25px' }}
	>
		<FormControl fullWidth>
			<Field {...props} />
		</FormControl>
	</GridItem>
);

export const HalfFieldSmall = props => (
	<GridItem
		xs={12}
		sm={6}
		md={6}
		style={props.gridStyle ? { ...props.gridStyle } : { marginBottom: '25px' }}
	>
		<FormControl fullWidth>
			<Field {...props} />
		</FormControl>
	</GridItem>
);



// WEBPACK FOOTER //
// ./src/components/CustomFields/CustomFields.jsx